import { Component, NgZone, OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { BaseModule } from 'shared/base/base.module'
import * as fromRoot from '../../reducers'
import { SignupFormComponent } from './signup-form/signup-form.component'

@Component({
  selector: 'app-register',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  imports: [RouterModule, BaseModule, SignupFormComponent],
})
export class SignupComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>()

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private zone: NgZone
  ) {}

  ngOnInit() {
    this.store
      .select(fromRoot.getMeState)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(me => {
        if (me && !me.must_change_password) {
          const url = `/${me.preferred_product}`
          this.zone.run(() => this.router.navigate([url]))
        } else if (me && me.must_change_password) {
          const url = '/profile'
          this.zone.run(() => this.router.navigate([url]))
        } else {
          return
        }
      })
  }
}
